/*
 * mocks/api/history.ts
 * Anvilo, Inc.
 *
 * This file contains call history API mocks
 *
 * Created by Artem Yefimenko on 10/08/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import { mock } from "../axios";

const API_URL = "https://testing-webapp-api.talkroute.com/api/";

const GET_CALL_HISTORY_URL = "v1/call-history?page=1";

export const mockedCalls = [
  {
    call_recording: null,
    call_result: null,
    called_number: "16504519942",
    caller_cname: null,
    caller_id: "13317173121",
    caller_number: null,
    date: "2020-07-30T10:47:57+0000",
    did_description: null,
    did_id: null,
    duration: 83,
    id: 31721935,
    is_call_recorded: false,
    number_dialed: "13317173121",
    type: "outbound",
    user_call_recording_permission_level: null,
  },
  {
    call_recording: null,
    call_result: "answered",
    called_number: null,
    caller_cname: "",
    caller_number: "16504519942",
    date: "2020-08-01T14:03:40+0000",
    did_description: null,
    did_id: null,
    duration: 27,
    id: 31721939,
    is_call_recorded: false,
    number_dialed: "17088660301",
    type: "inbound",
    user_call_recording_permission_level: null,
  },
  {
    call_recording: null,
    call_result: "hangup",
    called_number: null,
    caller_cname: "",
    caller_number: "16504519942",
    date: "2020-08-01T14:02:40+0000",
    did_description: null,
    did_id: null,
    duration: 27,
    id: 31721940,
    is_call_recorded: false,
    number_dialed: "17088660301",
    type: "inbound",
    user_call_recording_permission_level: null,
  },
  {
    call_recording: null,
    call_result: "missed",
    called_number: null,
    caller_cname: "",
    caller_number: "16504519942",
    date: "2020-08-01T14:05:40+0000",
    did_description: null,
    did_id: null,
    duration: 27,
    id: 31721945,
    is_call_recorded: false,
    number_dialed: "17088660301",
    type: "inbound",
    user_call_recording_permission_level: null,
  },
];

mock.onGet(`${API_URL}${GET_CALL_HISTORY_URL}`).reply((request) => {
  return [
    200,
    {
      data: mockedCalls,
    },
  ];
});
